import {VIEW_CANDIDATE,VIEW_CANDIDATE_ERROR, VIEW_CANDIDATE_SUCCESS, MATCHING_JOBS,MATCHING_JOBS_ERROR,MATCHING_JOBS_SUCCESS,
  JOB_DETAIL,JOB_DETAIL_SUCCESS,JOB_DETAIL_ERROR,
  SIMILAR_CADNIDATE,SIMILAR_CADNIDATE_ERROR,SIMILAR_CADNIDATE_SUCCESS,
  CADNIDATE_DETAIL,CADNIDATE_DETAIL_ERROR,CADNIDATE_DETAIL_SUCCESS,
  CANDIDATE_JOB_MAPPING,CANDIDATE_JOB_MAPPING_SUCCESS,CANDIDATE_JOB_MAPPING_ERROR,
  GET_CANDIDATE_JOB_MAPPING,GET_CANDIDATE_JOB_MAPPING_ERROR,GET_CANDIDATE_JOB_MAPPING_SUCCESS,
  DELETE_CANDIDATE_JOB_MAPPING,DELETE_CANDIDATE_JOB_MAPPING_SUCCESS,DELETE_CANDIDATE_JOB_MAPPING_ERROR,
  GET_CANDIDATE_ACTIVE_LOG,GET_CANDIDATE_ACTIVE_LOG_SUCCESS,GET_CANDIDATE_ACTIVE_LOG_ERROR
} from './actionTypes';
  
  const initialState = {
    loading: false,
    matchingjobLoading: false,
    similarCandidateLoder: false,
    candidateData:null,
    candidateError:null,
    matchingJobData:null,
    matchingJobError:null,
    jobDetails:null,
    jobDetailsError:null,
    similarCadidateData:null,
    similarCandidateData:null,
    similarCadidateError:null,
    candidateDetail:null,
    candidateDetailError:null,
    candidateJobMap:null,
    candidateJobMapError:null,
    getCandidateJobDetail:null,
    getCandidateJobDetailError:null,
    deleteCandidateJobDetail:null,
    deleteCandidateJobDetailError:null,
    activityLog: null,
  }
  
  const viewCandidateReducer = (state = initialState, action) => {
    switch (action.type) {
      //view candidate
      case VIEW_CANDIDATE:
        state = {
          ...state,
          loading: true,
          candidateError: null,
        }
        break
      case VIEW_CANDIDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          candidateData: action.payload,
          candidateError: null,
        }
        break
      case VIEW_CANDIDATE_ERROR:
       
        state = {
          ...state,
          loading: false,
          candidateData: null,
          candidateError: action.payload,
        }
        break
        //matching job
      case MATCHING_JOBS:
       
       state = {
          ...state,
          matchingJobData:null,
          matchingJobError: null,
        }
        break
      case MATCHING_JOBS_SUCCESS:
       
        state = {
          ...state,
          matchingjobLoading: false,
          matchingJobData: action.payload,
          matchingJobError: null,
        }
        break
      case MATCHING_JOBS_ERROR:
       
        state = {
          ...state,
          matchingjobLoading: false,
          matchingJobData: null,
          matchingJobError: action.payload,
        }
        break
        //Job detail
        case JOB_DETAIL:
       
          state = {
             ...state,
             loading: true,
             jobDetailsError: null,
           }
           break
         case JOB_DETAIL_SUCCESS:
          
           state = {
             ...state,
             loading: false,
             jobDetails: action.payload,
             jobDetailsError: null,
           }
           break
         case JOB_DETAIL_ERROR:
          
           state = {
             ...state,
             loading: false,
             jobDetails: null,
             jobDetailsError: action.payload,
           }
           break

           // Similar Candidate
           case SIMILAR_CADNIDATE:
       
          state = {
             ...state,
             similarCandidateData:null,
             similarCandidateLoder: true,
             similarCadidateError: null,
           }
           break
         case SIMILAR_CADNIDATE_SUCCESS:
           state = {
             ...state,
             similarCandidateLoder: false,
             similarCandidateData: action.payload,
             similarCadidateError: null,
           }
           break
         case SIMILAR_CADNIDATE_ERROR:
          
           state = {
             ...state,
             similarCandidateLoder: false,
             similarCandidateData: null,
             similarCadidateError: action.payload,
           }
           break
           // Candidate Details
           case CADNIDATE_DETAIL:
       
          state = {
             ...state,
             loading: true,
             candidateDetailError: null,
           }
           break
         case CADNIDATE_DETAIL_SUCCESS:
          
           state = {
             ...state,
             loading: false,
             candidateDetail: action.payload.clickedCandidate,
             similarCadidateError: null,
           }
           break
         case CADNIDATE_DETAIL_ERROR:
          
           state = {
             ...state,
             loading: false,
             candidateDetail: null,
             candidateDetailError: action.payload.clickedCandidate,
           }
           break
           //Set Candidate Job Mapping
           case CANDIDATE_JOB_MAPPING:
       
          state = {
             ...state,
             loading: true,
             candidateJobMapError: null,
           }
           break
         case CANDIDATE_JOB_MAPPING_SUCCESS:
          
           state = {
             ...state,
             loading: false,
             candidateJobMap: action.payload.candidateJob,
             candidateJobMapError: null,
           }
           break
         case CANDIDATE_JOB_MAPPING_ERROR:
          
           state = {
             ...state,
             loading: false,
             candidateDetail: null,
             candidateJobMapError: action.payload.candidateJob,
           }
           break
           // Get Candidate Job Mapping
           case GET_CANDIDATE_JOB_MAPPING:
       
          state = {
             ...state,
             jobMappingloder: true,
             getCandidateJobDetailError: null,
           }
           break
         case GET_CANDIDATE_JOB_MAPPING_SUCCESS:
          
           state = {
             ...state,
             jobMappingloder: false,
             getCandidateJobDetail: action.payload.getcandidateJob,
             getCandidateJobDetailError: null,
           }
           break
         case GET_CANDIDATE_JOB_MAPPING_ERROR:
          
           state = {
             ...state,
             jobMappingloder: false,
             getCandidateJobDetail: null,
             getCandidateJobDetailError: action.payload.getcandidateJob,
           }
           break
           // Delete Candidate Job Mapping
           case DELETE_CANDIDATE_JOB_MAPPING:
       
          state = {
             ...state,
             loading: true,
             deleteCandidateJobDetailError: null,
           }
           break
         case DELETE_CANDIDATE_JOB_MAPPING_SUCCESS:
          
           state = {
             ...state,
             loading: false,
             deleteCandidateJobDetail: action.payload.deletecandidateJob,
             deleteCandidateJobDetailError: null,
           }
           break
         case DELETE_CANDIDATE_JOB_MAPPING_ERROR:
          
           state = {
             ...state,
             loading: false,
             deleteCandidateJobDetail: null,
             deleteCandidateJobDetailError: action.payload.deletecandidateJob,
           }
           break
           //candidate active log
           case GET_CANDIDATE_ACTIVE_LOG: 
           state = {
             ...state,
             loading: true,
             activityLog: null
           }
           break
           case GET_CANDIDATE_ACTIVE_LOG_SUCCESS: 
           state = {
             ...state,
             loading: false,
             activityLog: action.payload
           }
           break
           case GET_CANDIDATE_ACTIVE_LOG_ERROR: 
           state = {
             ...state,
             loading: false,
             activityLog: null,
           }
           break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default viewCandidateReducer
  